import { render, staticRenderFns } from "./CardOneColumn.vue?vue&type=template&id=00b0fac6&scoped=true"
import script from "./CardOneColumn.vue?vue&type=script&lang=js"
export * from "./CardOneColumn.vue?vue&type=script&lang=js"
import style0 from "./CardOneColumn.vue?vue&type=style&index=0&id=00b0fac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b0fac6",
  null
  
)

export default component.exports